<template>
    <b-btn to="/spotlight" class="bg-white" variant="light" block size="lg">
        <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
                <div class="mr-2">
                    <font-awesome-icon
                        class="small-avatar branded"
                        icon="fa-duotone fa-stars"
                        size="lg"
                    />
                </div>
                Spotlight
            </div>
            <coin-badge v-if="topPrize" :amount="topPrize" label="Top Payout" />
        </div>
    </b-btn>
</template>

<script>
import { mapState } from "vuex";

export default {
    created() {
        this.$store.dispatch("spotlight/refresh");
    },
    computed: {
        ...mapState("spotlight", ["spotlight"]),
        topPrize() {
            return this.spotlight?.prizesDisplay?.[0]?.credits;
        },
    },
};
</script>
